<template>
  <article
          :class="{
            'tablet:flex-row': !odd,
            'tablet:flex-row-reverse': odd
          }"
          class="tablet:flex gap-x-12"
  >
    <div class="pt-8">
      <header>
        <h3
                :class="titleClass"
        >
          {{ page.title }}
        </h3>
      </header>
      <ContentRenderer :class="bodyClass" :value="page" class="with-free-text"/>
    </div>
    <picture
            v-if="imgUri"
            :class="pictureClass"
    >
      <media-source
              :dimensions="imgDimensions"
              :sizes="imgSizes"
              :uri="imgUri"
              as="source"
              format="webp"
      />
      <media-source
              :alt="page.title"
              :class-name="`w-full h-auto object-cover rounded-img ${imgAspectRatio}`"
              :dimensions="imgDimensions"
              :sizes="imgSizes"
              :uri="imgUri"
              as="img"
              format="jpg"
      />
    </picture>
  </article>
</template>
<script lang="ts" setup>
import type {PageCollectionItemBase} from "@nuxt/content";

const {
    page,
    titleClass = 'text-brand article-title mb-3',
    bodyClass = 'text-grey',
    odd = false,
    imgSizes = '50vw',
    pictureClass = 'w-full',
    imgDimensions = [
        {width: 480},
        {width: 960},
        {width: 1440},
        {width: 1920},
    ],
    imgAspectRatio = '',
} = defineProps<{
    page: PageCollectionItemBase
    titleClass?: string,
    bodyClass?: string,
    odd?: boolean,
    imgSizes?: string,
    pictureClass?: string,
    imgDimensions?: Array<{ width: number }>,
    imgAspectRatio?: string,
}>();
const imgUri = computed<string>(() => (page.meta?.imageRef as string || '').replace('/assets', ''));
</script>